import edgeCommon from '../common';

let vmImport = (function () {
    let addValidations = function() {
        $("#vm-import-form").validate({
            ignore: "",
            errorClass: "text-danger",
            rules: {
                "vm_name[]": "required",
                "memory_size[]": "required",
                "cpu[]": "required",
                "storage_size[]": "required",
                "os_system[]": "required",
                "os_version[]": "required",
                // keyword: "required"
            },
            errorPlacement: function (error, element) {
                error.insertAfter(element);
            },
        });
    }
    let initVmImport = function () {
        $(document).on("change", "#vm_import_user_id", function () {
            let userId = $(this).val();
            if(userId == '') {
                edgeCommon.swalWarning("Please select user");
                return;
            }
            $('#vm_import_table').addClass('d-none');
            $('.save-vm-import').addClass('d-none');
            $(".loading").removeClass("d-none");
            $.ajax({
                url: baseUrl + "/admin/vm-import/get-user-sites/" + userId,
                type: "GET",
                success: function (response) {
                    let html = "<option value=''>Select Site</option>";
                    let entries = Object.entries(response)
                    entries.forEach( ([key, val] = entry) => {
                        html += `<option value='${key}'>${val}</option>`;
                    });
                    $('#vm_import_site_id').html(html);
                    $(".loading").addClass("d-none");
                },
            });
        });

        $(document).on("change", "#vm_import_site_id", function () {
            let siteId = $(this).val();
            if(siteId == '') {
                edgeCommon.swalWarning("Please select site");
                return;
            }
            $('#vm_import_table').addClass('d-none');
            $('.save-vm-import').addClass('d-none');
            $(".loading").removeClass("d-none");
            
            let userId = $('#vm_import_user_id').val();
            console.log("vm_import_site_id click", userId);

            $.ajax({
                url: `${baseUrl}/admin/vm-import/${userId}/site/${siteId}`,
                type: "GET",
                success: function (response) {
                    $('#vm_import_table').removeClass('d-none');
                    $('.save-vm-import').removeClass('d-none');
                    $('#import_vm_data').html(response);
                    $(".loading").addClass("d-none");
                },
            });
        });

        $(document).on("click", "#vm_import_add_more", function () {
            $('#import_vm_data').append($('#import_vm_data tr:last').clone());
            $('#import_vm_data tr:last input').val('');
            $('#import_vm_data tr:last input.additional_drive').val(0);
            $('#import_vm_data tr:last input.memory_size').val(2);
            $('#import_vm_data tr:last input.cpu').val(2);
            $('#import_vm_data tr:last input.storage_size').val(100);
        });

        $(document).on("click", ".vm-import-remove", function () {
            const vmIdCount = $('.vm_id').length;
            const elm = $(this);
            if(vmIdCount == 1) {
                edgeCommon.swalWarning("You can not able delete this VM, at-least one VM required");
            } else {
                const vmId = $(this).parent().parent().find('.vm_id').val();
                console.log("vmId", vmId);
                if(vmId == '') {
                    $(this).parent().parent().remove();
                } else {
                    $.ajax({
                        url: baseUrl + "/admin/vm-import/" + vmId,
                        type: "DELETE",
                        processData: false,
                        contentType: false,
                        cache: false,
                        success: function (response) {
                            $(".loading").addClass("d-none");
                            if( response.status == "success" ){
                                elm.parent().parent().remove();
                                edgeCommon.swalSuccess(response.message);
                            } else {
                                edgeCommon.swalError(response.message);
                            }
                        },
                    });
                }
            }
        });

        $(document).on("click", ".save-vm-import", function () {
            $(".loading").removeClass("d-none");
            console.log('save-vm-import click');
            let userId = $("#vm_import_user_id").val();
            let siteId = $("#vm_import_site_id").val();
            if ($("#vm-import-form").valid()) {
                let formData = new FormData();
                const vmId = $('.vm_id').length;
                for (let i = 0; i < vmId; i++) {
                    formData.append('vm_id[]', $('.vm_id').eq(i).val());
                    formData.append('vm_name[]', $('.vm_name').eq(i).val());
                    formData.append('memory_size[]', $('.memory_size').eq(i).val());
                    formData.append('cpu[]', $('.cpu').eq(i).val());
                    formData.append('storage_size[]', $('.storage_size').eq(i).val());
                    formData.append('additional_drive_1[]', $('.additional_drive_1').eq(i).val());
                    formData.append('additional_drive_2[]', $('.additional_drive_2').eq(i).val());
                    formData.append('additional_drive_3[]', $('.additional_drive_3').eq(i).val());
                    formData.append('os_system[]', $('.os_system').eq(i).val());
                    formData.append('os_version[]', $('.os_version').eq(i).val());
                }
                console.log('formData', formData);
                if(userId) {
                    $.ajax({
                        url: `${baseUrl}/admin/vm-import/${userId}/site/${siteId}`,
                        type: "POST",
                        data: formData,
                        processData: false,
                        contentType: false,
                        cache: false,
                        success: function (response) {
                            console.log("response => ", response);
                            if( response.status == "success" ){
                                edgeCommon.swalSuccess(response.message).then(() => {
                                    window.location.reload();
                                });
                            } else {
                                edgeCommon.swalError(response.message);
                            }
                        },
                        error: function(xhr) { // if error occurred
                            let err = eval("(" + xhr.responseText + ")");
                            edgeCommon.swalError(err.message);
                            console.log(`Error occurred. please try again ${err.message}`);
                        },
                        complete: function() {
                            $(".loading").addClass("d-none");
                        },
                    });
                }
            }
        });

        $(document).on("change", ".os_system", function () {
            $(".loading").removeClass("d-none");
            let os = $(this).val();
            let index = $(this).parent().parent().index();
            console.log("index", index);
            $.ajax({
                url: baseUrl + "/admin/get-versions",
                type: "POST",
                dataType: "JSON",
                data: { os: os },
                success: function (response) {
                    if (response.status == "success") {
                        let html = '<option value="">Select Version</option>';
                        $.each(response.versions, function (i, v) {
                            html +='<option value="' + i + '">' + v + "</option>";
                        });
                        $(`.os_version:eq(${index})`).html(html);
                        $(".loading").addClass("d-none");
                    }
                },
            });

        });
    }


return {
    // public functions
    init: function () {
        addValidations();
        initVmImport();
    },
};
})();

$(document).ready(function () {
    vmImport.init();
});
